import {createAction} from '@reduxjs/toolkit';

export const setExtent = createAction('SEARCH_SET_EXTENT');
export const setDateRange = createAction('SEARCH_SET_DATE_RANGE');
export const setFilter = createAction('SEARCH_SET_FILTER');
export const resetFilters = createAction('SEARCH_RESET_FILTERS');
export const toggleType = createAction('SEARCH_TOGGLE_TYPE');
